import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./App.css";
import "line-awesome/dist/line-awesome/css/line-awesome.min.css";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";

// Intercept third-party Google reCAPTCHA internal background timer errors
window.addEventListener("error", (event) => {
  if (
    event.filename?.includes("recaptcha") ||
    event.filename?.includes("gstatic.com") ||
    (typeof event.message === "string" && event.message.includes("reading 'style'"))
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RecoilRoot>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </RecoilRoot>
  </React.StrictMode>
);

reportWebVitals();
